import React, {useState} from 'react';
import { Grid } from '@material-ui/core';
import SearchableTable from '../components/toolsrender';
import Content from '../components/Content';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import UomIcon from '@material-ui/icons/FormatListNumbered';
import StatIcon from '@material-ui/icons/Dvr';
import LocationIcon from '@material-ui/icons/NearMe';
import InsIcon from '@material-ui/icons/FileCopy';
import BuIcon from '@material-ui/icons/Business';
import InactiveIcon from '@material-ui/icons/Cancel'
import DeptIcon from '@material-ui/icons/Apartment';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import Inactive from '../components/inactiverender';

const options = [
	'Create Config',
	'Create Dept',
	'Create BU',
	'Back'
  ];
  
const ITEM_HEIGHT = 48;

function TabPanel(props) {
const { children, value, index, ...other } = props;

return (
	<div
	role="tabpanel"
	hidden={value !== index}
	id={`scrollable-force-tabpanel-${index}`}
	aria-labelledby={`scrollable-force-tab-${index}`}
	{...other}
	>
	{value === index && (
		<Box p={3}>
		<Typography>{children}</Typography>
		</Box>
	)}
	</div>
);
}
  
TabPanel.propTypes = {
children: PropTypes.node,
index: PropTypes.any.isRequired,
value: PropTypes.any.isRequired,
};

  function a11yProps(index) {
	return {
	  id: `scrollable-force-tab-${index}`,
	  'aria-controls': `scrollable-force-tabpanel-${index}`,
	};
  }
  
  const useStyles = makeStyles((theme) => ({
	root: {
	  flexGrow: 1,
	  width: '100%',
	  backgroundColor: theme.palette.background.paper,
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightRegular,
	},
  }));



const ToolsDetails = () => {
	const classes = useStyles();
  	const [value, setValue] = React.useState(0);

	const history = useHistory();

	const [rowsToPush, setRowsToPush] = useState([]);
	const [selectedRawEdit, setSelectedRawEdit] = useState({});
	const [anchorEl, setAnchorEl] = React.useState(null);
  	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (e) => {
		console.log(e.target.textContent);
		switch(e.target.textContent){
			case 'Create Config':
				history.push({pathname: '/tools/create'});
				break;
			case 'Create Dept':
				history.push({pathname: '/dept/create'});
				break;
			case 'Create BU':
				history.push({pathname: '/bu/create'});
				break;			
			case 'Back':
				history.goBack();
				break;
			default:
		}
		
		setAnchorEl(null);
	};

	const handleChange = (event, newValue) => {
    	setValue(newValue);
  	};
	return (
		<Content>
			<div>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"
					onClick={handleClick}
				><MoreVertIcon />
				</IconButton>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"
				><span>Tools Detail</span>
				</IconButton>
				
				<Menu
					id="long-menu"
					anchorEl={anchorEl}
					keepMounted
					open={open}
					onClose={handleClose}
					PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 5,
						width: '20ch',
					},
					}}
				>
					{options.map((option) => (
					<MenuItem key={option} selected={option === 'Pyxis'} onClick={(e)=>handleClose(e)}>
						{option}
					</MenuItem>
					))}
				</Menu>
			</div>

	  <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          indicatorColor="primary"
          textColor="primary"
          aria-label="scrollable force tabs example"
        >
          <Tab label="UoM" icon={<UomIcon />} {...a11yProps(0)} />
          <Tab label="Asset Status" icon={<StatIcon />} {...a11yProps(1)} />
          <Tab label="Location" icon={<LocationIcon />} {...a11yProps(2)} />
		  <Tab label="Insurance Coverage" icon={<InsIcon />} {...a11yProps(3)} />
          <Tab label="Departments" icon={<DeptIcon />} {...a11yProps(4)} />
          <Tab label="Business Units" icon={<BuIcon />} {...a11yProps(5)} />
		  <Tab label="Assignee Groups" icon={<InactiveIcon />} {...a11yProps(6)} />
		  <Tab label="Inactive Records" icon={<InactiveIcon />} {...a11yProps(7)} />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Unit of Measure</p>
        <Grid item xs={12} md={12}>
				<SearchableTable
					table = {'misc'}
                    qString = "&config_type=uom" 
					defaultSortColumn = "configName"
					keyIdentifier = "idMaster"
					filterTable = ""
					filters = { false }
					filterQuery
					enableFormEdit = { true }
					enableRawEdit = { true }
					selectedRawEdit = { [selectedRawEdit] }
					enableSelect = { false }
					useDataRowsFromParent = { false }
					displayedHeaders={[
						{
							key: 'configName',
							displayedHeader: 'Config Name',
							displayedLength: 30,
							withList: false,

						},
						{
							key: 'configType',
							displayedHeader: 'Config Type',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 30,
							withList: false,
						},
					   ]}

					displayRows = {[
					
						{
							key: 'configName',
							displayedHeader: 'Configuration Name',
							displayedLength: 50,
						},
						{
							key: 'configType',
							displayedHeader: 'Configuration Type',
							displayedLength: 50,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 50,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 50,
						},
					]}
				/>
			</Grid>
      </TabPanel>

      <TabPanel value={value} index={1}>
	  <p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Asset Status</p>
        <Grid item xs={12} md={12}>
				<SearchableTable
					table = {'misc'}
                    qString = "&config_type=assetstat" 
					defaultSortColumn = "configName"
					keyIdentifier = "idMaster"
					filterTable = ""
					filters = { false }
					filterQuery
					enableFormEdit = { true }
					enableRawEdit = { true }
					selectedRawEdit = { [selectedRawEdit] }
					enableSelect = { false }
					useDataRowsFromParent = { false }
					displayedHeaders={[
						{
							key: 'configName',
							displayedHeader: 'Config Name',
							displayedLength: 30,
							withList: false,

						},
						{
							key: 'configType',
							displayedHeader: 'Config Type',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 30,
							withList: false,
						},
					   ]}

					displayRows = {[
					
						{
							key: 'configName',
							displayedHeader: 'Configuration Name',
							displayedLength: 50,
						},
						{
							key: 'configType',
							displayedHeader: 'Configuration Type',
							displayedLength: 50,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 50,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 50,
						},
					]}
				/>
			</Grid>
      </TabPanel>
      
	  <TabPanel value={value} index={2}>
	  <p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Plant / Site</p>
        <Grid item xs={12} md={12}>
				<SearchableTable
					table = {'misc'}
                    qString = "&config_type=PlantSite" 
					defaultSortColumn = "configName"
					keyIdentifier = "idMaster"
					filterTable = ""
					filters = { false }
					filterQuery
					enableFormEdit = { true }
					enableRawEdit = { true }
					selectedRawEdit = { [selectedRawEdit] }
					enableSelect = { false }
					useDataRowsFromParent = { false }
					displayedHeaders={[
						{
							key: 'configName',
							displayedHeader: 'Config Name',
							displayedLength: 30,
							withList: false,

						},
						{
							key: 'configType',
							displayedHeader: 'Config Type',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 30,
							withList: false,
						},
					   ]}

					displayRows = {[
					
						{
							key: 'configName',
							displayedHeader: 'Configuration Name',
							displayedLength: 50,
						},
						{
							key: 'configType',
							displayedHeader: 'Configuration Type',
							displayedLength: 50,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 50,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 50,
						},
					]}
				/>
			</Grid>

			<p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Building / Structure</p>

			<Grid item xs={12} md={12}>
				<SearchableTable
					table = {'misc'}
                    qString = "&config_type=BuildingStructure" 
					defaultSortColumn = "configName"
					keyIdentifier = "idMaster"
					filterTable = ""
					filters = { false }
					filterQuery
					enableFormEdit = { true }
					enableRawEdit = { true }
					selectedRawEdit = { [selectedRawEdit] }
					enableSelect = { false }
					useDataRowsFromParent = { false }
					displayedHeaders={[
						{
							key: 'configName',
							displayedHeader: 'Config Name',
							displayedLength: 30,
							withList: false,

						},
						{
							key: 'configType',
							displayedHeader: 'Config Type',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 30,
							withList: false,
						},
					   ]}

					displayRows = {[
					
						{
							key: 'configName',
							displayedHeader: 'Configuration Name',
							displayedLength: 50,
						},
						{
							key: 'configType',
							displayedHeader: 'Configuration Type',
							displayedLength: 50,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 50,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 50,
						},
					]}
				/>
			</Grid>


			<p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Room</p>

			<Grid item xs={12} md={12}>
				<SearchableTable
					table = {'misc'}
                    qString = "&config_type=Room" 
					defaultSortColumn = "configName"
					keyIdentifier = "idMaster"
					filterTable = ""
					filters = { false }
					filterQuery
					enableFormEdit = { true }
					enableRawEdit = { true }
					selectedRawEdit = { [selectedRawEdit] }
					enableSelect = { false }
					useDataRowsFromParent = { false }
					displayedHeaders={[
						{
							key: 'configName',
							displayedHeader: 'Config Name',
							displayedLength: 30,
							withList: false,

						},
						{
							key: 'configType',
							displayedHeader: 'Config Type',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 30,
							withList: false,
						},
					   ]}

					displayRows = {[
					
						{
							key: 'configName',
							displayedHeader: 'Configuration Name',
							displayedLength: 50,
						},
						{
							key: 'configType',
							displayedHeader: 'Configuration Type',
							displayedLength: 50,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 50,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 50,
						},
					]}
				/>
			</Grid>

      </TabPanel>


	  <TabPanel value={value} index={3}>
        <p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Classification of Insurance Coverage</p>
        <Grid item xs={12} md={12}>
				<SearchableTable
					table = {'misc'}
                    qString = "&config_type=insurance" 
					defaultSortColumn = "configName"
					keyIdentifier = "idMaster"
					filterTable = ""
					filters = { false }
					filterQuery
					enableFormEdit = { true }
					enableRawEdit = { true }
					selectedRawEdit = { [selectedRawEdit] }
					enableSelect = { false }
					useDataRowsFromParent = { false }
					displayedHeaders={[
						{
							key: 'configName',
							displayedHeader: 'Config Name',
							displayedLength: 30,
							withList: false,

						},
						{
							key: 'configType',
							displayedHeader: 'Config Type',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 30,
							withList: false,
						},
					   ]}

					displayRows = {[
					
						{
							key: 'configName',
							displayedHeader: 'Configuration Name',
							displayedLength: 50,
						},
						{
							key: 'configType',
							displayedHeader: 'Configuration Type',
							displayedLength: 50,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 50,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 50,
						},
					]}
				/>
			</Grid>
      </TabPanel>



      <TabPanel value={value} index={4}>
	  <p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Departments</p>
        <Grid item xs={12} md={12}>
				<SearchableTable
					table = {'depts'}
                    qString = "&department=" 
					defaultSortColumn = "deptName"
					keyIdentifier = "idMaster"
					filterTable = ""
					filters = { false }
					filterQuery
					enableFormEdit = { true }
					enableRawEdit = { true }
					selectedRawEdit = { [selectedRawEdit] }
					enableSelect = { false }
					useDataRowsFromParent = { false }
					displayedHeaders={[
						{
							key: 'deptName',
							displayedHeader: 'Department Name',
							displayedLength: 30,
							withList: false,

						},
						{
							key: 'orclMap',
							displayedHeader: 'Oracle Map',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 30,
							withList: false,
						},
					   ]}

					displayRows = {[
					
						{
							key: 'deptName',
							displayedHeader: 'Department Name',
							displayedLength: 110,
						},
						{
							key: 'orclMap',
							displayedHeader: 'Oracle Map',
							displayedLength: 60,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 40,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 50,
						},
					]}
				/>
			</Grid>
      </TabPanel>
      
	  <TabPanel value={value} index={5}>
	  <p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Business Units</p>
        <Grid item xs={12} md={12}>
				<SearchableTable
					table = {'company'}
                    qString = "&company_name=" 
					defaultSortColumn = "companyName"
					keyIdentifier = "idMaster"
					filterTable = ""
					filters = { false }
					filterQuery
					enableFormEdit = { true }
					enableRawEdit = { true }
					selectedRawEdit = { [selectedRawEdit] }
					enableSelect = { false }
					useDataRowsFromParent = { false }
					displayedHeaders={[
						{
							key: 'companyName',
							displayedHeader: 'Business Unit',
							displayedLength: 30,
							withList: false,

						},
						{
							key: 'assetCode',
							displayedHeader: 'Asset Code',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'famasCode',
							displayedHeader: 'FAMAS Code',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 30,
							withList: false,
						},
					   ]}

					displayRows = {[
					
						{
							key: 'companyName',
							displayedHeader: 'Business Unit',
							displayedLength: 150,
						},
						{
							key: 'assetCode',
							displayedHeader: 'Asset Code',
							displayedLength: 50,
						},
						{
							key: 'famasCode',
							displayedHeader: 'FAMAS Code',
							displayedLength: 50,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 50,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 50,
						},
					]}
				/>
			</Grid>
      </TabPanel>

	  <TabPanel value={value} index={6}>
      	  	<p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Assinee Groups</p>
			<Grid item xs={12} md={12}> 
			<SearchableTable
					table = {'misc'}
                    qString = "&config_type=assigneeGroups" 
					defaultSortColumn = "configName"
					keyIdentifier = "idMaster"
					filterTable = ""
					filters = { false }
					filterQuery
					enableFormEdit = { true }
					enableRawEdit = { true }
					selectedRawEdit = { [selectedRawEdit] }
					enableSelect = { false }
					useDataRowsFromParent = { false }
					displayedHeaders={[
						{
							key: 'configName',
							displayedHeader: 'Config Name',
							displayedLength: 30,
							withList: false,

						},
						{
							key: 'configType',
							displayedHeader: 'Config Type',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 30,
							withList: false,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 30,
							withList: false,
						},
					   ]}

					displayRows = {[
					
						{
							key: 'configName',
							displayedHeader: 'Configuration Name',
							displayedLength: 50,
						},
						{
							key: 'configType',
							displayedHeader: 'Configuration Type',
							displayedLength: 50,
						},
						{
							key: 'createdBy',
							displayedHeader: 'Created By',
							displayedLength: 50,
						},
						{
							key: 'updatedBy',
							displayedHeader: 'Updated By',
							displayedLength: 50,
						},
					]}
				/>
			</Grid>
			
      </TabPanel>

      <TabPanel value={value} index={7}>
      	  <p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Inactive Records</p>
		<Grid item xs={12} md={12}> <Inactive /></Grid>	
      </TabPanel>




    </Content>
	);
};

export default ToolsDetails;
